/*
  Revcontent conversion pixels.
  Loaded only for templates that opt in from layout/theme.liquid
  (currently product.main_product_lymph-updated-bf-champs-selector-taboola).

  The pixel URL comes from the data attributes on the script tag, so the
  token stays in the layout and nothing is hardcoded here:
    <script src="revcontent-pixels.js" data-revcontent-atc="..."></script>

  "Add to cart" fires on the selector's ATC button and on the sticky bar's
  ATC button. Both can navigate away immediately (champs redirect or
  straight-to-checkout), so the request uses fetch(keepalive) where
  available and falls back to an Image().
*/

var revcontentAtcSelector = '.product-selector_atc, [data-sticky-atc], .mpsp_buyonce-btn';
var revcontentAtcUrl = null;
var revcontentLastFired = 0;

function revcontentFire(url) {
  // The same click can bubble through more than one handler; ignore repeats.
  var now = Date.now();
  if (now - revcontentLastFired < 1000) return;
  revcontentLastFired = now;

  try {
    if (window.fetch) {
      // keepalive keeps the request alive through the redirect that
      // usually follows add to cart.
      window.fetch(url, { mode: 'no-cors', credentials: 'include', keepalive: true }).catch(function () {});
      return;
    }
  } catch (error) {
    // fall through to the image pixel below
  }

  var pixel = new Image(1, 1);
  pixel.src = url;
}

function revcontentHandleClick(event) {
  if (!revcontentAtcUrl || !event.target.closest) return;
  if (event.target.closest(revcontentAtcSelector)) revcontentFire(revcontentAtcUrl);
}

function revcontentInit() {
  var script = document.currentScript || document.querySelector('script[data-revcontent-atc]');
  if (!script) return;

  revcontentAtcUrl = script.getAttribute('data-revcontent-atc');
  if (!revcontentAtcUrl) return;

  // Capture phase: runs before the theme's own handler redirects.
  document.addEventListener('click', revcontentHandleClick, true);
}

revcontentInit();
